import { IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { driverVersions } from 'app/registries/consts/tabular-consts';
import { LinkedServiceUtils } from './linked-service.utils';

export const prestoAuthTypes = {
    Anonymous: 'Anonymous',
    PrestoLDAP: 'LDAP'
};

@Metamodel.model({
    name: 'Presto',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Presto_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Presto_DisplayText)
    ]
})
export class PrestoLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.VersionLabel
    })
    public version?: driverVersions = driverVersions.v2;

    @Metamodel.attribute({
        display: stringResources.ModelName_Host
    })
    public host?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServerVersion
    })
    public serverVersion?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Catalog
    })
    public catalog?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Port
    })
    public port?: number;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName
    })
    public username?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public password?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_EnableSSL
    })
    public enableSsl?: boolean;

    @Metamodel.attribute({
        display: stringResources.ModelName_EnableServerCertificateValidation
    })
    public enableServerCertificateValidation?: boolean = true;

    @Metamodel.attribute({
        display: stringResources.ModelName_TrustedCertPath
    })
    public trustedCertPath?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UseSystemTrustStore
    })
    public useSystemTrustStore?: boolean;

    @Metamodel.attribute({
        display: stringResources.ModelName_AllowHostNameCNMismatch
    })
    public allowHostNameCNMismatch?: boolean;

    @Metamodel.attribute({
        display: stringResources.ModelName_AllowSelfSignedServerCert
    })
    public allowSelfSignedServerCert?: boolean;

    @Metamodel.attribute({
        display: stringResources.Timezone
    })
    public timeZoneID?: string;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public convertV1toV2(context: { inlineDataset?: boolean }): PrestoLinkedService {
        return LinkedServiceUtils.commonV1ToV2(context, this) as PrestoLinkedService;
    }
}
